<template>
  <div class="vx-col lg:w-1/2 w-full">
    <vx-card title="Try & Buy Form">
      <div class="mt-5">
        <form>
          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full ">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full ">
                  <span>Customer Mobile No<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    type="tel"
                    v-validate="'required|min:11|max:11'"
                    data-vv-validate-on="blur"
                    name="mobile"
                    placeholder="Use 11 digit mobile number"
                    v-model="customer_mobile"
                    data-vv-as="Customer Mobile No"
                    @keypress="onlyNumber"
                    class="w-full"/>
                  <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row"></div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Customer NID<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="text" v-validate="'required|greaterThanZero|min:10|max:17'" data-vv-as="NID No" @keypress="onlyNidNumber"
                            v-model="customer_nid"
                            name="customer_nid"/>
                  <span class="text-danger text-sm" v-show="errors.has('customer_nid')">{{ errors.first('customer_nid') }}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full ">
                  <span>Customer Name<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-validate="'required'" data-vv-as="Customer Name" name="customer_name"   type="text" v-model="customer_name"/>
                  <span class="text-danger text-sm"  v-show="errors.has('customer_name')">{{ errors.first('customer_name') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Customer Address<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-textarea class="w-full" v-validate="'required'" data-vv-as="Customer Address" name="customer_address" v-model="customer_address"/>
                  <span class="text-danger text-sm"  v-show="errors.has('customer_address')">{{ errors.first('customer_address') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Product Article<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-validate="'required'" data-vv-as="Product Article" name="product_article"
                            type="text" v-model="product_article"/>
                  <span class="text-danger text-sm" v-show="errors.has('product_article')">{{ errors.first('product_article') }}</span>
                  <p v-if="product_article.length > 5" class="text-danger text-sm"> Article no should be 5 digit.</p>
                  <p v-if="product_article.length > 0 && product_article.length < 5  " class="text-danger text-sm"> Article no should be 5 digit.</p>
                </div>
              </div>

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Product SL No<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-validate="'required'" data-vv-as="Product SL No" name="product_sl"
                            type="text" v-model="product_sl"/>
                  <span class="text-danger text-sm"
                        v-show="errors.has('product_sl')">{{ errors.first('product_sl') }}</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
                     color="success" class="mb-2 float-right" @click="saveTrail" :disabled="!validateForm">Send
          </vs-button>

        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
  import addTrail from '../graphql/WashingMachineTrailCreate.gql'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import { Validator } from 'vee-validate';
  import gql from 'graphql-tag'
  import moment from 'moment'
  const dict = {
  }
  Validator.localize('en', dict.en)
  export default {
    data(){
      return{
        product_article :'',
        product_sl :'',
        customer_nid :'',
        customer_name :'',
        customer_mobile :'',
        customer_address :''
      }
    },
    apollo: {
      searchCustomer: {
        query: gql`
         query searchCustomer($phone:String, $nid:String){
          searchCustomer(phone:$phone, nid:$nid){
            id
            phone
            nid
            parsonal{
              name
              last_name
            }
            contact{
              presentAddress{
                division
                district
                thana
                address
                postal_code
              }
          }
          }
         }
         `,
        variables () {
          if(this.customer_mobile){
            return {
              phone: this.customer_mobile
            }
          }
          /*if(this.customer_nid){
            return {
              nid: this.customer_nid
            }
          }*/
        },
        update: (data) => data.searchCustomer
      },
      /*productQuer: {
        query: products,
        manual: true,
        result ({data, loading}) {
          if (!loading) {
            this.allproducts = data.products;
            console.log('Product', this.allproducts)
          }
        }
      }*/
    },
    watch: {
      searchCustomer (value) {
        console.log("------", value);
        if(value !== null){
          this.searchCustomer = value;
          this.customer_mobile = value.phone
          this.customer_nid = value.nid
          this.customer_name = value.parsonal.name +' '+ value.parsonal.last_name
          this.customer_address = value.contact.presentAddress.address +', '+ value.contact.presentAddress.thana+', '+value.contact.presentAddress.district+', '+value.contact.presentAddress.division+' - '+value.contact.presentAddress.postal_code
          console.log("searchCustomer = ", this.searchCustomer);
        }
      }
    },
    created() {
      this.$validator.extend(
        'greaterThanZero',{
          getMessage: field =>  field + ' NID must be 10, 13 or 17 digit.',
          validate: (value) => {

            // value must be > zero
            if (value <= 0 ) {
              this.customer_nid = null;
            }
            if (value.toString().length === 10){
              return true;
            }
            else if(value.toString().length === 13){
              return true
            }else if(value.toString().length === 17){
              return true
            }else {
              return false;
            }
          }
        });
    },
    computed: {
      validateForm () {
        return !this.errors.any() && this.product_article !== '' && this.product_sl !== '' && this.customer_nid !== '' && this.customer_name !== '' && this.customer_mobile !== ''&& this.customer_address !== ''
      }
    },
    methods :{
      async saveTrail () {
        await this.$apollo.mutate({
          mutation: addTrail,
          variables: {
            product_article: this.product_article || "",
            product_sl: this.product_sl|| "",
            customer_nid: this.customer_nid|| "",
            customer_name: this.customer_name|| "",
            customer_mobile: this.customer_mobile|| "",
            customer_address: this.customer_address|| ""
          }
        }).then((data) => {
          console.log('Data = ', data);
          this.$router.push('/try_and_buy').catch(() => {});
          this.$vs.notify({
            title: 'Save',
            text: 'New Customer Successfully Added.',
            color: "success",
            position: 'top-right'
          })

        }).catch((error) => {
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          })
        })
      },
      onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      onlyNidNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
    },
    components: {
      FormWizard,
      TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
<style>
  sup{
    color:red
  }
</style>
